import api, { handleApiError } from './api';
import { WalletBalance, Transaction, TransactionFilters } from '../types/wallet';

export const walletService = {
  /**
   * Get wallet balance
   */
  async getBalance(): Promise<WalletBalance> {
    try {
      const response = await api.get<WalletBalance>('/wallet/balance');
      if (!response.data) {
        return { balance: 0, user_id: 0 };
      }
      const balance = Number(response.data.balance);
      return {
        ...response.data,
        balance: Number.isNaN(balance) ? 0 : balance,
      };
    } catch (error) {
      console.error('Error fetching wallet balance:', error);
      throw new Error(handleApiError(error));
    }
  },

  /**
   * Get transaction history
   */
  async getTransactions(filters?: TransactionFilters): Promise<Transaction[]> {
    try {
      const response = await api.get<{ transactions: Transaction[]; total: number; limit: number; offset: number }>('/wallet/transactions', {
        params: filters,
      });
      return response.data?.transactions ?? [];
    } catch (error) {
      console.error('Error fetching transactions:', error);
      throw new Error(handleApiError(error));
    }
  },

  /**
   * Purchase tokens
   */
  async purchaseTokens(packageId: number, paymentMethod: string): Promise<{ success: boolean; transaction: Transaction }> {
    try {
      const response = await api.post('/wallet/purchase', {
        package_id: packageId,
        payment_method: paymentMethod,
      });
      return response.data;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  },
};
